export enum Currency {
  BRL = 'BRL'
}
